export const RJBuscaEntity = {
    codparcmotorista: 0
    ,dtinicial: null
    ,dtfinal: new Date()
}